import PropTypes from 'prop-types';
import styles from './FJGeneratePrivacySettings.module.less';
import FJPrivacySetting from '../../../FJCommunity/FJCommonComponent/FJPrivacySetting/FJPrivacySetting.jsx';
import FJLocalStore from '../../../../store/FJLocalStore.js';
import ArrowIcon from '../../../../assets/svg/button-right.svg?react';
import classNames from 'classnames';
import { useMemo } from 'react';
import { SHARE_SETTING_LIST } from '../../../../config/dataConfig/FJCommunityData.js';

const FJGeneratePrivacySettings = props => {
    const { privacyStatus, onPrivacySettingChange } = props;

    const showName = useMemo(() => {
        const item = SHARE_SETTING_LIST.find(item => item.value === privacyStatus);
        return item?.name || '';
    }, [privacyStatus]);

    return (
        <div className={styles.image_number_box}>
            <div className={styles.image_number_title}>{FJLocalStore._('visibility')}</div>

            <FJPrivacySetting
                value={privacyStatus}
                onChange={onPrivacySettingChange}
                placement='rightBottom'
                offsetLeft={20}
                hideShareToSociety={true}
                renderTrigger={({ ref, onClick }) => {
                    return (
                        <div className={styles.image_number_btu} ref={ref} onClick={onClick}>
                            {FJLocalStore._(showName)}
                            <ArrowIcon
                                className={classNames(styles.arrow_icon, { [styles.arrow_icon_active]: false })}
                            />
                        </div>
                    );
                }}
            />
        </div>
    );
};

FJGeneratePrivacySettings.propTypes = {
    privacyStatus: PropTypes.string,
    onPrivacySettingChange: PropTypes.func,
};
export default FJGeneratePrivacySettings;
